var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomerenovation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.25L15.75 6V8H14.5V15.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 1.5V0.75H14.5V3.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11375 2.75L10.0513 4.85938L10.9494 6.0625C11.0278 6.1678 11.0848 6.28753 11.117 6.41485C11.1492 6.54216 11.156 6.67457 11.137 6.80452C11.118 6.93446 11.0736 7.05939 11.0064 7.17218C10.9391 7.28497 10.8503 7.38341 10.745 7.46187L9.34125 8.50688L9.9375 9.30625C10.535 10.1094 12.0325 10.8644 12.6294 11.6663C12.7718 11.8501 12.8761 12.0605 12.9362 12.2852C12.9963 12.5098 13.0111 12.7442 12.9796 12.9746C12.9481 13.205 12.871 13.4269 12.7528 13.6271C12.6346 13.8274 12.4777 14.0021 12.2912 14.1411C12.1047 14.28 11.8924 14.3804 11.6667 14.4363C11.441 14.4923 11.2063 14.5026 10.9766 14.4669C10.7468 14.4311 10.5264 14.3499 10.3284 14.228C10.1303 14.1061 9.95856 13.9459 9.82313 13.7569C9.22563 12.9544 8.93125 11.3037 8.33313 10.5006L7.73688 9.69938L6.33313 10.745C6.12063 10.9022 5.85454 10.9689 5.59301 10.9305C5.33148 10.8921 5.0958 10.7517 4.9375 10.54L4.03813 9.33687L0.25 6L8 0.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4506 12.6008C11.4801 12.6405 11.4972 12.688 11.4997 12.7374C11.5022 12.7867 11.49 12.8357 11.4646 12.8782C11.4393 12.9206 11.4019 12.9546 11.3573 12.9758C11.3126 12.997 11.2627 13.0045 11.2138 12.9974C11.1649 12.9902 11.1192 12.9687 11.0825 12.9356C11.0458 12.9024 11.0197 12.8592 11.0076 12.8113C10.9955 12.7633 10.9979 12.7129 11.0144 12.6663C11.031 12.6197 11.061 12.5791 11.1006 12.5496C11.1269 12.5299 11.1569 12.5157 11.1887 12.5076C11.2206 12.4996 11.2537 12.4979 11.2862 12.5026C11.3187 12.5074 11.35 12.5185 11.3782 12.5354C11.4064 12.5522 11.431 12.5744 11.4506 12.6008Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03906 9.33691L7.64844 6.64941",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45312 5.30555L10.055 4.85742",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.13867 4.59863L3.69805 6.17676",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 8.25V14.75C0.25 15.0152 0.355357 15.2696 0.542893 15.4571C0.73043 15.6446 0.984784 15.75 1.25 15.75C1.51522 15.75 1.76957 15.6446 1.95711 15.4571C2.14464 15.2696 2.25 15.0152 2.25 14.75V12.75C2.25 12.5511 2.32902 12.3603 2.46967 12.2197C2.61032 12.079 2.80109 12 3 12V12C3.19891 12 3.38968 12.079 3.53033 12.2197C3.67098 12.3603 3.75 12.5511 3.75 12.75V13.375C3.75 13.6071 3.84219 13.8296 4.00628 13.9937C4.17038 14.1578 4.39294 14.25 4.625 14.25V14.25C4.85706 14.25 5.07962 14.1578 5.24372 13.9937C5.40781 13.8296 5.5 13.6071 5.5 13.375V12.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomerenovation);
export default __webpack_public_path__ + "static/media/home renovation.37d3b54d.svg";
export { ForwardRef as ReactComponent };